<template>
  <div>
    <el-dialog :visible="show" @close="close" center width="820px">
      <h3 v-if="type === 'edit'">以下图片素材已被删除，请在素材库上传后重新插入。</h3>
      <h3 v-else>
        以下图片素材已被删除，请在素材库上传后重新插入。选择继续发布后文章将默认不显示已删除图片。
      </h3>
      <div v-for="item in list" :key="item.id">
        <h3>{{ item.title }}</h3>
        <el-table :data="item.deleted_media" style="width: 100%">
          <el-table-column label="素材" center>
            <template slot-scope="scope">
              <img
                v-if="!scope.row.mate_type || scope.row.mate_type === 1"
                :src="scope.row.data"
                alt=""
              />
              <video v-if="scope.row.mate_type === 2" :src="scope.row.data" />
              <audio v-if="scope.row.mate_type === 3" :src="scope.row.data" />
            </template>
          </el-table-column>
          <el-table-column props="mate_name" label="" center>
            <template slot-scope="scope">
              {{ scope.row.mate_name }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="title" style="width: 100%; text-align: start">
        <h4>素材使用情况</h4>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">返 回</el-button>
        <el-button v-if="type === 'edit'" type="primary" @click="affirm">继续保存</el-button>
        <!-- <el-button v-else type="primary" @click="affirm">确定发布</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { arrUnique } from '@/utils/util';
export default {
  props: ['show', 'data', 'type'],
  data() {
    return {
      list: [],
    };
  },
  watch: {
    show: {
      handler(value) {
        if (value) {
          const val = this.data;
          val.forEach((item) => {
            item.deleted_media = arrUnique(item.deleted_media, 'mate_id');
          });
          this.list = val;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    affirm() {
      this.$emit('affirm');
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 188px;
  height: 80px;
  border-radius: 8px;
  margin-right: 50px;
}
h3 {
  margin-bottom: 15px;
}
</style>
